<template>
<!--目标选择-->
  <div id="studyaim">
    <h1>简单一步，让我们更懂你</h1>
    <div class="step">
      <h3>考试目标</h3>
      <ul>
        <!-- 保留设计图数据
        <li class="active">教师资格-笔试</li>
        <li>教师资格-面试</li>
        <li>教师招聘-笔试</li>
        <li>教师招聘-面试</li>
        -->
        <li :class="subject === item.id ? 'active' : ''" v-for="(item, index) in aimData.subject" :key="index" @click="setSubject(item.id)">{{item.name}}</li>
      </ul>
    </div>
    <div class="step">
      <h3>考试学段</h3>
      <ul>
        <!-- 保留设计图数据
        <li class="active">幼儿教师资格</li>
        <li>小学教师资格</li>
        <li>初中教师资格</li>
        <li>高中教师资格</li>
        -->
        <li :class="period === item.id ? 'active' : ''" v-for="(item, index) in aimData.period" :key="index" @click="setPeriod(item.id)">{{item.name}}</li>
      </ul>
    </div>
    <a @click="postSubjectPeriod()" :class="['fixed-bar', subject !== 0 && period !==0 ? 'active' : '']">
      开始学习
    </a>
  </div>
</template>

<script>
export default {
  name: 'StudyAim',
  data () {
    return {
      aimData: {},
      subject: this.$store.state.subject ? this.$store.state.subject : 0,
      period: this.$store.state.period ? this.$store.state.period : 0
    }
  },
  mounted () {
    this.getExamSection()
  },
  methods: {
    getExamSection () {
      // if (this.$store.state.subject === 0 || this.$store.state.period === 0) return false
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_examination_objectives',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.aimData = res.data.data
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    setSubject (uid) {
      this.subject = uid
    },
    setPeriod (uid) {
      this.period = uid
    },
    postSubjectPeriod () {
      if (!this.subject || !this.period) {
        alert('请选择考试科目或报考级别')
        return false
      }
      let data = {
        subject: this.subject,
        period: this.period
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_examination_section',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.$store.dispatch('alterSubject', this.subject)
            this.$store.dispatch('alterPeriod', this.period)
            // alert('提交成功')
            this.back()
            // this.$router.push({name: 'Index'})
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  #studyaim
    h1
      margin: 1rem 0 .66rem
      font-size: .48rem
      color: #30343C
      text-align: center
    .step
      padding: 0 .4rem
      margin-top: .48rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      h3
        margin-bottom: .32rem
        font-size: .36rem
        color: #20262D
        font-weight: 600
        text-align: left
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &::before
          content: ""
          display: inline-block
          width: .24rem
          height: .24rem
          background: url(../../assets/icon/rulevip_icon_h3.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
          margin-right: .16rem
      ul
        display: flex
        justify-content: space-between
        flex-wrap: wrap
        li
          width: 2.6rem
          height: .64rem
          line-height: .64rem
          background-color: #F9F9F9
          margin-top: .2rem
          font-size: .28rem
          color: #7D7E83
          text-align: center
          -webkit-border-radius: .32rem
          -moz-border-radius: .32rem
          border-radius: .32rem
          &.active
            color: #1E81F2
    a.fixed-bar
      position: fixed
      bottom: .6rem
      left: 50%
      display: block
      width: 3.72rem
      height: .96rem
      line-height: .96rem
      background-color: rgba(30,129,242,0.26)
      font-size: .32rem
      color: #fff
      text-align: center
      -webkit-border-radius: .6rem
      -moz-border-radius: .6rem
      border-radius: .6rem
      -webkit-transform: translate(-50%, 0)
      -moz-transform: translate(-50%, 0)
      -ms-transform: translate(-50%, 0)
      -o-transform: translate(-50%, 0)
      transform: translate(-50%, 0)
      &.active
        background-color: #1E81F2
</style>



// WEBPACK FOOTER //
// src/components/login/StudyAim.vue